<template lang="pug">
div
  v-row(dense)
    v-col(cols=3)
      y-select.text-sm(v-model="paymentType" placeholder="Panel" :items="paymentTypes" item-text="name" item-value="id" attach)
    v-col(cols=5)
      //- y-select(v-if="paymentType === 'panel'" v-model="selectedPanel" placeholder="Choose panel" :items="panels" item-text="name" item-value="id" attach)
      panel-list-dropdown(v-if="paymentType === 'panel'" v-model="selectedPanel" :items="panels" placeholder="Choose panel" attach)
      y-select.text-sm(v-else v-model="selectedSelfPayMethod" placeholder="Choose payment method" :items="selfPayMethods" item-text="name" item-value="id" attach)
    v-col(cols=4)
      v-text-field.text-sm.round-xl(outlined dense height="48" hide-details v-model="amount" :prefix="$currency.symbol" type="number")

  .d-flex.align-center.my-2
    .text-xs.mr-2(v-if="note") Payment notes: {{ note }}
    .text-xs.font-semibold.underline.clickable.mr-2(@click="showPaymentNoteDialog = true") {{ note ? 'Edit' : 'Add payment notes' }}

  .d-flex.align-center.mt-8
    .flex-grow-1
      .text-xs.font-semibold.underline.clickable(@click="cancel") Cancel
    y-button.mr-2(v-if="paymentType === 'panel' && selectedPanel" label="Verify panel" outlined size="sm" @click="showVerifyPanelDialog = true")
    y-button(label="Record payment" size="sm" @click="recordPayment" :loading="isLoading" :disabled="disabledRecordPayment")

  payment-note-dialog(v-if="showPaymentNoteDialog" :open.sync="showPaymentNoteDialog" :note="note" @onSaved="updateNote")
  verify-panel-dialog(v-if="showVerifyPanelDialog" :open.sync="showVerifyPanelDialog" :selectedPanel="selectedPanel")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import PanelListDropdown from '@/components/clinic/custom/PanelListDropdown.vue'
import PaymentNoteDialog from '@/components/clinic/dialogs/PaymentNoteDialog.vue'
import VerifyPanelDialog from '@/components/clinic/dialogs/VerifyPanelDialog.vue'

export default {
  name: 'AddPaymentItem',
  components: { PanelListDropdown, PaymentNoteDialog, VerifyPanelDialog },
  props: {
    panels: {
      type: Array,
      required: true,
      default: () => []
    },
    selfPayMethods: {
      type: Array,
      required: true,
      default: () => []
    },
    leadId: {
      type: Number,
      required: true,
    },
    invoiceNo: {
      default: null
    },
    registration: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    note: null,
    paymentType: null,
    paymentTypes: [
      { id: 'self-pay', name: 'Self-pay' },
      { id: 'panel', name: 'Panel' },
    ],
    selectedPanel: null,
    selectedSelfPayMethod: null,
    amount: null,
    showPaymentNoteDialog: false,
    showVerifyPanelDialog: false,
    isLoading: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    selectedPayment () {
      return this.paymentType === 'panel' ? this.panels.find(i => i.id === this.selectedPanel) : this.selfPayMethods.find(i => i.id === this.selectedSelfPayMethod)
    },
    disabledRecordPayment () {
      return !this.amount || (this.paymentType === 'self-pay' && !this.selectedSelfPayMethod) || (this.paymentType === 'panel' && !this.selectedPanel)
    },
    leadPid () {
      return this.$route.params.pid
    }
  },
  mounted () {
    // Auto select panel if in default payment
    if (this.registration?.default_payment?.type === 'panel') {
      this.paymentType = this.paymentTypes[1].id
      this.selectedPanel = this.registration.default_payment.panel.id
    } else {
      this.paymentType = this.paymentTypes[0].id
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    updateNote (note) {
      this.note = note
    },
    cancel () {
      this.$emit('cancel')
    },
    recordPayment () {
      this.isLoading = true
      const amountInCent = (parseFloat(this.amount)).toFixed(this.$currency.exponent).replace('.', '')
      const payload = {
        amount: amountInCent,
        gateway: 'direct',
        lead: this.leadId,
        paid: this.paymentType === 'self-pay',
        channel: this.paymentType,
        ref_id: this.selectedPayment?.id,
        payment_method: this.selectedPayment?.name,
        internal_description: this.note
      }
      const endpoint = `/transactions/`
      this.axios.post(endpoint, payload)
        .then(resp => {
          this.updateOldActivityLog(endpoint, payload, resp.data, 'POST')
          const amount = this.$options.filters.displayPrice(resp.data.amount, this.$currency)
          this.createActivityLog('add_transaction', `${resp.data.payment_method} amount ${amount} was recorded`)
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
      // Open cash drawer for cash payment method
      const cashPaymentMethod = this.selfPayMethods.find(method => method.name.toLowerCase() === 'cash') || null
      const isSelfPay = this.paymentType === 'self-pay'
      if (isSelfPay && cashPaymentMethod && this.selectedSelfPayMethod === cashPaymentMethod.id) {
        this.axios.post(`/clinics/${this.company.slug}/open_cash_drawer`)
          .then(() => {
            // this.showMessage(['success', 'Cash drawer opened'])
          })
          .catch(() => {
            // this.showMessage(['error', 'Failed to open cash drawer'])
          })
      }
    },
    updateOldActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'checkout',
        activity: `Add payment (#${this.invoiceNo})`,
        raw_data: { endpoint, payload, response, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    createActivityLog (tag, activity) {
      const payload = {
        company: this.company.id,
        app_model: 'form.lead',
        object_id: this.leadPid,
        tag,
        group: 'checkout',
        activity
      }
      this.$axios.post('/actions', payload).catch(() => {})
    }
  }
}
</script>